
const Skeletontable = () => {
  return (
      <tr>
{/*         <td className="c-table__trbody">
          <span className="c-table__item-skeleton"></span>
        </td> */}
        <td className="c-table__trbody">
          <div className="c-avatar-user">
            <div className="c-avatar-user__avatar-skeleton" />
            <div className="c-avatar-user__box-data">
              <div className="c-avatar-user__name-skeleton"/>
              <div className="c-avatar-user__email-skeleton"/>
            </div>
          </div>
        </td>
        <td className="c-table__trbody"> <div className="c-table__item-skeleton"></div></td>
        <td className="c-table__trbody"> <div className="c-table__item-skeleton"></div></td>
        <td className="c-table__trbody"> <div className="c-table__item-skeleton"></div></td>
        <td className="c-table__trbody"> <div className="c-table__item-skeleton"></div></td>
        <td className="c-table__trbody">
          <div className="c-table__item-skeleton"></div>
        </td>
      </tr>
  )
}

export default Skeletontable